// Add your JS customizations here
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import Draggable from "gsap/Draggable";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin, Draggable);

(function($) {

/* 	$(window).on('load', function() {
		gsap.to('#preloader', {opacity: 0, display: 'none', ease: "power2.out",  duration: 0.5});
	}); */


	$('.navbar-toggler').on('click', function(){
		if ( $(this).hasClass('is-active') ) {
			$(this).removeClass('is-active');
			$('#main-nav, .navbar-menu').removeClass('is-active');
		} else {
			$(this).addClass('is-active');
			$('#main-nav, .navbar-menu').addClass('is-active');
		}
	});

	if ( $('.hz-wrapper').length ) {

		if ( window.matchMedia('(min-width: 768px)').matches ) {

			var target = window.location.hash;
			// delete hash so the page won't scroll to it
			window.location.hash = "";
			$(window).on('load', function() {
				if (target && $(target).length ) {
					horizontalScroll.scroll((document.querySelector(target).offsetLeft - document.querySelector('#main-nav').offsetWidth + 1) * dragRatio);
					history.replaceState('', '', target);
				}
			});

			if ( $('.navbar-bottom').length ) {
				//$('.horizontal-section--image').css('padding-bottom',$('.navbar-bottom').outerHeight());
				$('.horizontal-scroll').css('bottom',$('.navbar-bottom').outerHeight()+20);
			}

			const sections = gsap.utils.toArray(".hz-section");
			let maxWidth = 0;

			const getMaxWidth = () => {
				maxWidth = 0;
				sections.forEach((section) => {
					maxWidth += section.offsetWidth;
				});
				//console.log(maxWidth);
			};
			getMaxWidth();
			ScrollTrigger.addEventListener("refreshInit", getMaxWidth);

			var scrollTween = gsap.to(sections, {
				x: () => `-${maxWidth - window.innerWidth}`,
				ease: "none",
			});

			var _navbot = false;
			if ( $(".navbar-bottom").length ) {
				_navbot = true;
			}

			var horizontalScroll = ScrollTrigger.create({
				animation: scrollTween,
				trigger: ".hz-content",
				pin: true,
				scrub: 1,
				end: () => `+=${maxWidth}`,
				invalidateOnRefresh: true,
				onUpdate: ({progress}) => {
					if ( _navbot && progress == 1 ) {
						$(".navbar-bottom a.is-active").removeClass ('is-active');
						$('.navbar-bottom li:last-child a').addClass('is-active');
					}
				}
			});

			// dragRatio changed to the part in the horizontal sroll that's there to calculate the offset between the duration of the scroll and the amount of x-translation of the content (that needs to be included there when triggering things when certain sections reach a certain point in the viewport - as seen in commented out part above)

			var dragRatio = (maxWidth / (maxWidth - window.innerWidth))

			var drag = Draggable.create(".drag-proxy", {
				trigger: '.hz-content',
				type: "x",
				allowContextMenu: true,
				dragClickables: false,
				onPress() {
					this.startScroll = horizontalScroll.scroll();
				},
				onDrag() {
					horizontalScroll.scroll(this.startScroll - (this.x - this.startX) * dragRatio);
				}
			})[0];
		}
	}

	if ( $('#home-wrapper').length ) {
		if ( window.matchMedia('(min-width: 768px)').matches ) {

			const sections = gsap.utils.toArray(".hz-section");
			sections.forEach(function (elem) {
				ScrollTrigger.create({
					trigger: elem,
					containerAnimation: scrollTween,
					start: "left 5.5%",
					//end: "left 100%",
					//markers: true,
					onEnter: function () {
						$("#main-nav").removeClass (function (index, className) {
							return (className.match (/(^|\s)(scheme-|color-)\S+/g) || []).join(' ');
						});
						$('#main-nav').addClass('scheme-'+$(elem).data('sidebar')).addClass('color-'+$(elem).data('sidebarbg'));
					},
					/* onEnterBack: function () {
						$("#main-nav").removeClass (function (index, className) {
							return (className.match (/(^|\s)(scheme-|bg-)\S+/g) || []).join(' ');
						});
						$('#main-nav').addClass('scheme-'+$(elem).data('sidebar')).addClass('bg-'+$(elem).data('sidebarbg'));
					}, */
					/* onLeave: function () { 
						console.log('left:');
						console.log(elem);
					}, // assure that the element is hidden when scrolled into view */
					onLeaveBack: function () {
						$("#main-nav").removeClass (function (index, className) {
							return (className.match (/(^|\s)(scheme-|color-)\S+/g) || []).join(' ');
						});
						$('#main-nav').addClass('scheme-'+$(elem).prev().data('sidebar')).addClass('color-'+$(elem).prev().data('sidebarbg'));
					} // assure that the element is hidden when scrolled into view
				});
			});

			// Move triangle 
			var triangleMove = gsap.timeline({
				scrollTrigger: {
					trigger: ".home-what--services",
					containerAnimation: scrollTween,
					start: "center 40%",
					end: () => `+=${window.innerWidth*2}`,
					//pin: true,
					scrub: true,
					//markers: true,
				}
			}).to(".home-what--services",{
				x: window.innerWidth*2.1,
				yPercent: -35,
				ease: "none",
			});

			// spin triangle
			var triangleSpin = gsap.timeline({
				scrollTrigger: {
					trigger: ".home-what--services-triangle",
					containerAnimation: scrollTween,
					start: "center 45%",
					end: () => `+=${window.innerWidth*2}`,
					//markers: {startColor: "purple",endColor: "red",fontSize: "12px"},
					scrub: true,
				}
			}).to(".home-what--services-triangle", {
				rotation: 1200,
				ease: "none"
			});

			let services = gsap.utils.toArray(".home-what--service");
			gsap.set(services, {
				autoAlpha: 0
			});
			var serviceAnim = [];
			services.forEach((el, index) => {

				var _start = 'center '+ (30 - index*19)+'%';

				serviceAnim[index] = gsap.timeline({
					delay: 1,
					scrollTrigger: {
						trigger: el,
						containerAnimation: scrollTween,
						start: _start,
						end: () => `+=${window.innerWidth/5}`,
						scrub: true,
						//markers: {startColor: "blue",endColor: "yellow",fontSize: "12px"},
					}
				});

				serviceAnim[index].to(el, {
					autoAlpha: 1,
					duration: 1,
					ease: "power3.inOut"
				}).to(el, {
					autoAlpha: 0,
					duration: 1,
					ease: "power3.inOut"
				});
			});
		}
	}

	var videoElement = document.getElementById('projectVideo');
	var projectSearch = window.location.search ? window.location.search : '';

	$(document).on('click', '.showProject', function(e){
		e.preventDefault();
		let projectID = $(this).data('project');
		let projectSlug = $(this).data('slug');
		if ( window.location.search ) {
			projectSearch = window.location.search;
		} else {
			projectSearch = '';
		}

		$.ajax({
			url: '/wp-json/wp/v2/project/' + projectID,
			success: function (data, textStatus, response) {
				if (data) {
					//console.log (data);

					$.each(data.job_data, function(i, item) {
						if ( item != '' && i != 'job_link' ) {
							$('.modal-meta').append('<p>'+item+'</p>');
						}
					});

					$('#projectTitle').html(data.title.rendered);

					let separator = '';
					if ( data.project_data.country != '' && data.project_data.industry != '' ) {
						separator = ' | ';
					}

					$('#projectMeta').html(data.project_data.country+separator+data.project_data.industry);
					if ( data.project_data.headline != '' ) {
						$('#projectHeadlineTitle').show();
						$('#projectHeadline').html(data.project_data.headline);
					} else {
						$('#projectHeadlineTitle').hide();
					}
					
					if ( data.project_data.idea != '' ) {
						$('#projectIdeaTitle').show();
						$('#projectIdea').html(data.project_data.idea);
					} else {
						$('#projectIdeaTitle').hide();
					}

					if ( data.project_data.goal != '' ) {
						$('#projectGoalTitle').show();
						$('#projectGoal').html(data.project_data.goal);
					} else {
						$('#projectGoalTitle').hide();
					}
					
					if ( data.project_data.video != '' ) {
						$('#projectVideo').show();
						videoElement.pause();
						$('#projectVideo source').attr('src',data.project_data.video);
						if ( data.project_data.poster != '' ) {
							videoElement.setAttribute('poster',data.project_data.poster);
						}
						videoElement.load();
					} else {
						$('#projectVideo').hide();
					}

					if ( data.project_data.results != '' ) {
						$('#projectResultsTitle').show();
						$.each(data.project_data.results, function(i, item) {
							if ( item != '' ) {
								$('#projectResults').append('<div class="col-12 col-md"><div class="row"><div class="col-3 col-md-4 col"><img src="'+item.icon+'" class="img-fluid mb-3"></div><div class="col-9 col-md-8">'+item.text+'</div></div></div>');
							}
						});
					} else {
						$('#projectResultsTitle').hide();
					}

					if ( !$('body').hasClass('home') ) {
						history.pushState(null,null,projectSlug+projectSearch);
					}

				}

				$('#projectModal').modal({
					backdrop: 'static'
				});
			},
			cache: false
		});
	});

	$('#projectModal').on('hide.bs.modal', function (event) {
		if ( !$('body').hasClass('home') ) {
			if ( $('body').data('lang') == 'es' ) {
				var slug = '/es/casos/';
			} else if ( $('body').data('lang') == 'pt' ) {
				var slug = '/pt/casos-pt/';
			} else {
				var slug = '/en/cases/';
			}
			history.pushState(null,null,window.location.origin+slug+projectSearch);
		}
		$('#projectMeta, #projectHeadline, #projectIdea, #projectGoal, #projectResults').html('');
		videoElement.pause();
		$('#projectVideo source').attr('src','');
		videoElement.setAttribute('poster','');
		videoElement.load();
	});

	if ( window.location.hash != '' ) {
		if ( window.location.hash.includes('project') ) {
			$('#project-'+window.location.hash.substring(1)).trigger('click');
		} else {
			ScrollTrigger.addEventListener("refresh", function(){
				let _target = window.location.hash;
				horizontalScroll.scroll(document.querySelector(_target).offsetLeft + window.innerWidth*($(_target).index()+( $(_target).index() > 2 ? 1 : 0 ))/$(".home-section").length);
			});
		}
	}

	if ( $('#horizontal-wrapper').length ) {
		if ( window.matchMedia('(min-width: 768px)').matches && $('.navbar-bottom').length ) {
			const sections = gsap.utils.toArray(".hz-section");
			sections.forEach(function (elem) {
				ScrollTrigger.create({
					trigger: elem,
					containerAnimation: scrollTween,
					start: "left 5.5%",
					onEnter: function () {
						$(".navbar-bottom a.is-active").removeClass ('is-active');
						$('a[href="#'+$(elem).attr('id')+'"]').addClass('is-active');
					},
					onLeaveBack: function () {
						$(".navbar-bottom a.is-active").removeClass ('is-active');
						$('a[href="#'+$(elem).prev().attr('id')+'"]').addClass('is-active');
					} // assure that the element is hidden when scrolled into view
				});
			});
		}
	}

	$('a[href^=#]').not('.showProject, .dropdown-toggle').on('click', function(e){
		let _target = $(this).attr('href');
		if ( $(_target).length ) {
			if ( $('.navbar-toggler').hasClass('is-active') ) {
				$('.navbar-toggler').trigger('click');
			}
			if ( window.matchMedia('(min-width: 768px)').matches ) {
				e.preventDefault();
				horizontalScroll.scroll((document.querySelector(e.target.getAttribute("href")).offsetLeft - document.querySelector('#main-nav').offsetWidth + 1) * dragRatio);
				history.replaceState('', '', _target);
			}
		} else {
			window.location.href = window.location.origin+'/'+_target;
		}
	});

	$('.about-sections-header').on('click', function(){
		if ( $(this).next().is(":hidden") ) {
			$('.about-sections-body').slideUp(300);
			$(this).next().slideDown(300,function(){
				gsap.to(window, {duration: 0.5, scrollTo: $(this).prev().offset().top});
			});
		} else {
			$('.about-sections-body').slideUp();
		}
	});

	if ( $('#about-wrapper').length ) {

/* 		const aboutSections = gsap.utils.toArray(".about-section");
		aboutSections.forEach(function (elem, index) {

			ScrollTrigger.create({
				trigger: elem,
				//containerAnimation: scrollTween,
				markers: true,
				start: "top top",
				end: () => `+=100`,
				pin: true,
				onEnter: function () {
					console.log('enter');
					gsap.to($(elem).prev().find('.about-sections-body'), 0.3, {height: 0, ease: Power2.easeOut});
					gsap.to($(elem).find('.about-sections-body'), 0.3, {height: "auto", ease: Power2.easeOut});
					//$(elem).find('.about-sections-header').trigger('click');
				},
				onEnterBack: function () {
					console.log('enterBack');
				},
				onLeave: function () { 
					console.log('leave');
				},
				onLeaveBack: function () {
					console.log('leaveBack');
					gsap.to($(elem).prev().find('.about-sections-body'), 0.3, {height: "auto", ease: Power2.easeOut});
					gsap.to($(elem).find('.about-sections-body'), 0.3, {height: 0, ease: Power2.easeOut});
				} // assure that the element is hidden when scrolled into view
			});
		});

		aboutSections.forEach(function (elem, index) {
			console.log(index);
			gsap.set($(elem).find('.about-sections-body'), {height: 0});
		}); */

/* 		var targets = gsap.utils.toArray(".about-sections-body");
		
		var middleTargets = targets;
		var first = middleTargets.shift();
		var last = middleTargets.pop();
		
		console.log(first);
		console.log(middleTargets);
		console.log(last);
		
		gsap.set(first, { display: "block" });

		var end = $('.page-header').outerHeight() + $('.about-sections li').length * $(window).outerWidth() * .38 + $('.about-sections li').length * $('.about-sections-header').outerHeight() + $(window).outerWidth();
		console.log(end);
		
		const timeline = gsap.timeline({
		  scrollTrigger: {
			trigger: ".about-sections",
			scrub: 0.3,
			start: "top top",
			end: '+='+end, // try diff options here
			markers: true,
			pin: true
		  }
		});
		timeline
		  .to(first, { display: "none", duration: 1 })
		  .to(middleTargets, {
			display: "block",
			duration: 1,
			stagger: {
			  each: 2,
			  yoyo: true,
			  repeat: 1
			}
		  })
		  .to(last, {
			duration: 1,
			display: "block"
		  }); */

/* 		  const sections = gsap.utils.toArray(".vt-section");
		  let maxHeight = 0;

		  const getmaxHeight = () => {
			  maxHeight = 0;
			  sections.forEach((section) => {
				  maxHeight += section.offsetHeight;
			  });
			  //maxHeight = maxHeight + window.innerHeight;
			  console.log(maxHeight);
		  };
		  getmaxHeight();
		  ScrollTrigger.addEventListener("refreshInit", getmaxHeight);

		  var scrollTween = gsap.to(sections, {
			  y: () => `-${maxHeight - window.innerHeight}`,
			  ease: "none",
		  });

		  var verticalScroll = ScrollTrigger.create({
			  animation: scrollTween,
			  trigger: ".vt-content",
			  pin: true,
			  scrub: 1,
			  end: () => `+=${maxHeight - window.innerHeight}`,
			  invalidateOnRefresh: true
		  }); */

		  // dragRatio changed to the part in the horizontal sroll that's there to calculate the offset between the duration of the scroll and the amount of x-translation of the content (that needs to be included there when triggering things when certain sections reach a certain point in the viewport - as seen in commented out part above)

			//var dragRatio = (maxHeight / (maxHeight - window.innerHeight))
			/* var dragRatio = 1.5;
			console.log(dragRatio); */

			/* var drag = Draggable.create(".drag-proxy", {
				trigger: '.vt-content',
				type: "y",
				allowContextMenu: true,
				onPress() {
					this.startScroll = verticalScroll.scroll();
					//console.log('start: '+this.startScroll);
				},
				onDrag() {
					//console.log('scroll: '+this.startScroll - (this.y - this.startY) * dragRatio);
					console.log(this);
					console.log('scroll: '+this.y);
					//console.log('scroll: '+this.startY);
					verticalScroll.scroll(this.startScroll - (this.y - this.startY) * dragRatio);
				}
			})[0]; */

			/* Draggable.create('.vt-content', {
				type:"y", 
				allowContextMenu: true,
				inertia: true,
				onDrag:function()
				{
					console.log(this.y);
				},
				bounds:
				{
					maxY:0, minY:-( $(document).height() - $(window).height() )
				},
				//edgeResistance:0.7
			}); */

		/* $(window).on('mousewheel swipe keypress', function(event, touch) {
			if (event.type == 'mousewheel' && event.originalEvent.wheelDelta >= 0) {
				var direction = 1;
			} else if (event.type == 'mousewheel' && event.originalEvent.wheelDelta <= 0) {
				var direction = 0;
			} else if (event.type == 'swipe' && touch.direction == 'up') {
				var direction = 0;
			} else if (event.type == 'swipe' && touch.direction == 'down') {
				var direction = 1;
			} else {
				var direction = undefined;
			}

		}).keydown(function(event) {
			if ( !window.header_home_anim.isActive() ) {
				if (event.keyCode == '40' ){
					window.header_home_anim.play();
				} else if (event.keyCode == '123' ){
					if ( jQuery(window).scrollTop() == 0 && window.header_home_anim.time() > 2 ) {
						$('body').addClass('oh');
						window.header_home_anim.reverse();
					}
				}
			}
		}); */
	}

	if ( $('#cases-container').length ) {

		function AnimateCases() {

			let proxy = { skew: 0 },
			skewSetter = gsap.quickSetter(".cases-item", "skewY", "deg"), // fast
			clamp = gsap.utils.clamp(-20, 20); // don't let the skew go beyond 20 degrees. 
		
			ScrollTrigger.create({
			onUpdate: (self) => {
				let skew = clamp(self.getVelocity() / -300);
				// only do something if the skew is MORE severe. Remember, we're always tweening back to 0, so if the user slows their scrolling quickly, it's more natural to just let the tween handle that smoothly rather than jumping to the smaller skew.
				if (Math.abs(skew) > Math.abs(proxy.skew)) {
				proxy.skew = skew;
				gsap.to(proxy, {skew: 0, duration: 0.8, ease: "power3", overwrite: true, onUpdate: () => skewSetter(proxy.skew)});
				}
			}
			});
			
			// make the right edge "stick" to the scroll bar. force3D: true improves performance
			gsap.set(".cases-item", {transformOrigin: "right center", force3D: true});

			gsap.utils.toArray(".cases-item").forEach(function(section) {
				gsap.timeline({
					onStart: function(){
						$('#cases-container').find('.cases-invisible').removeClass('cases-invisible');
					},
					scrollTrigger: {
						trigger: section,
						start: 'top+=100px bottom',
						end: 'bottom-=100px top',
						//end: () => `+=${window.innerHeight}`,
						scrub: 1,
						//markers: true
					}
				}).fromTo(section, { rotate: '5deg', xPercent: 20, scale: 0.8 }, {
					duration: 1,
					rotate: '-5deg',
					xPercent: -10,
					scale: 1,
					//autoAlpha: 1,
					//ease: "expo",
					overwrite: "auto"
				}).fromTo(section.querySelector(".cases-title"),{duration: 0.25, xPercent: 10},{xPercent: -10}, '<0.25');
				//.fromTo(section.querySelector(".cases-date"),{duration: 0.2, yPercent: 200, autoAlpha: 0},{yPercent: 5, autoAlpha: 1}, '<');

				gsap.timeline({
					scrollTrigger: {
						trigger: section.querySelector(".cases-body"),
						start: 'bottom bottom',
						end: 'bottom center+=25%',
						//end: () => `+=${window.innerHeight}`,
						scrub: 1,
						//markers: true
					}
				}).fromTo(section.querySelector(".cases-body"),{duration: 0.1, yPercent: 20, opacity: 0},{yPercent: 0, opacity: 1});

				gsap.timeline({
					scrollTrigger: {
						trigger: section,
						start: 'top+=40% top',
						end: 'bottom-=20% top',
						//end: () => `+=${window.innerHeight}`,
						scrub: 1,
						//markers: true
					}
				}).fromTo(section,{filter:"blur(0px)"},{filter:"blur(10px)"});

			});
		}
		AnimateCases();

		var query = '', page = 1, loading = false, count;
		var api_url = '/wp-json/wp/v2/project/?per_page=100&';
		var casesPage = (function(){

			const currentLang = $('body').data('lang');
			
			var init = function() {
				//Trigger selected filters if event page url has parameters
				if ( $('#cases-wrapper').length && window.location.search ) {
					$.each(window.location.search.split('&'), function(index, value){
						var main_id = '#'+value.substr(0, value.indexOf('=')).replace('?','')+'-';
						var ids = value.slice(value.indexOf('=')+1).split(',');
						$.each(ids, function(index, value){
							$(main_id+''+value).prop('checked','checked').parent().parent().collapse('show');
						});
					});
					$('#clearFilters').addClass('is-active');
				}
			}

			var concatIds = function(id) {
				var values = '';
				$('#filters-'+id+' input:checked').each(function(){
					if (values != '') {
						values = values + ',' + $(this).val();
					} else {
						values = $(this).val();
					}
				});
				return values;
			}

			var filter = function() {
				var filters,
					$loader;

				page = 1;

				filters = {
					industry: concatIds('industry'),
					country: concatIds('country'),
				};

				gsap.timeline()
					//.to('#cases-container', {duration: 1, height:400})
					.to('#cases-container .cases-item', {duration: 0.3, opacity: 0, y: 20, stagger: 0.15, ease: "power2.out"},'-=1');

				query = '?', count = 0, length = Object.keys(filters).length;
				$.each(filters, function(index, value ){
					count++;
					//console.log(value);
					if ( value != '' && value !== undefined) {
						query = query+index+'='+value+(count < length ? '&' : '');
					}
				});

				//console.log(query);

				if (/.*&$/.test(query)) {
					query = query.substring(0, query.length - 1);
					$('#clearFilters').addClass('is-active');
				} else if (query == '?' || query == '') {
					query = '';
					$('#clearFilters').removeClass('is-active');
				} else {
					$('#clearFilters').addClass('is-active');
				}
				history.pushState(null,null,window.location.pathname+query);

				//console.log(api_url + query);

				$.ajax({
					url: api_url + query.substring(1),
					success: function (data, textStatus, response) {
						if (ScrollTrigger.getAll().length) {
							ScrollTrigger.getAll().forEach(st => st.kill(true));
						}

						$('#cases-container').html('');

						totalpages = Number(response.getResponseHeader('X-WP-TotalPages'));

						//console.log (data);
						if (data.length) {
							$.each(data, function(key,value){

								if ( currentLang == value.project_data.language ) {
									$('#cases-container').append('<article class="cases-invisible '+value.project_data.post_class.join(" ")+'" id="post-'+value.id+'"><a href="#" class="showProject" id="project-'+value.id+'" title="'+value.title.rendered+'" data-project="'+value.id+'" data-slug="'+value.link+'"><header class="cases-header"><div class="cases-image color-'+value.project_data.color+'" style="background-image: url('+value.project_data.image+');"><h2 class="cases-title">'+value.title.rendered+'</h2></div></header><div class="cases-body"><div class="cases-body--title">'+value.project_data.label+'</div><p>'+value.project_data.idea+'</p></div></a></article>');
								}

							});
						} else {
							$('#cases-container').html('<div class="cases-item cases-item--noresults"><p>Unfortunately there\'s no results for this query, please try different filters.</p><p><a href="#" class="filters-button" id="resetFilters">Or reset all filters</p></div>');
						}

						AnimateCases();
					},
					cache: false
				});

			};

			$('.cases-filter-list input').on('change', function(){
				filter();
			});

			$(document).on('click', '#clearFilters, #resetFilters', function(e){
				e.preventDefault();
				$('.cases-filter-list input').prop('checked',false);
				filter();
			});

			$(document).ready(function() {
				init();
			});

			return {
				init: init
			}
		})();

	}

	if ( $('body').hasClass('single-project') ) {
		$('#projectModal').modal();
	}

})( jQuery );
